import { Link } from "react-router-dom";
import { IoChevronForwardOutline } from "react-icons/io5";
import { BsArrowRightShort } from "react-icons/bs";
import JobCard from "../../../Molecules/JobCard";

export default function CurrentOpenings({ featuredJobs }) {
  return (
    <section id="openings" className="py-10 lg:py-12">
      <div className="containers-min mx-auto px-4 py-8">
        <div className="text-center mb-10">
          {/* <p className="section-eyebrow mb-2">Join The Team</p> */}
          <h3 className="text-center font-gilroy">Current Openings</h3>
          <p className=" mt-3 first-letter:md:mt-5 lg:mt-7 max-w-6xl leading-normal sm:leading-9 font-poppins mx-auto">
        Ready to build what’s next in electric mobility? Explore our current opportunities across engineering, technology, sales, and operations, and find where you can make an impact at VerdeMobility.
          </p>
        </div>

        {featuredJobs.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-[var(--vm-text-gray)] mb-3">
              We don't have any open roles matching this view right now — but new positions go up often.
            </p>
            <Link to="/careers/openings" className="btn-outline-brand text-sm">Browse All Departments</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {featuredJobs.map((job) => <JobCard job={job} key={job.id} />)}
          </div>
        )}

        <div className="text-center mt-10">
           <a href="/careers/openings" className='text-gray-600'>
          <button
                                  className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                                >
                                  <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                  </span>
                                  View All Openings
                                </button>
          </a>
          {/* <Link to="/careers/openings" className="btn-vm-morph">
            <span className="morph-icon"><ArrowRight size={16} /></span>
            <span>View All Openings</span>
          </Link> */}
        </div>
      </div>
    </section>
  );
}
